import { CovalentBalanceItem } from '@shared/types/frontend';
import { BiSortAlt2 } from 'react-icons/bi';
import classNames from '@/lib/misc/classNames';
import { toSpecialFixed } from '@/lib/misc/utils';
interface Props {
  totalAmount: string;
  asset: CovalentBalanceItem;
  isSwitched: boolean;
  setIsSwitched: (value: boolean) => void;
  enableSwitch?: boolean;
}
const FromAssetsAmountSelection = ({
  totalAmount,
  asset,
  isSwitched,
  setIsSwitched,
  enableSwitch
}: Props) => {
  const displayAmount = totalAmount?.replace(/,/g, '') || '0';
  const displayCurrency = isSwitched ? asset?.contract_ticker_symbol || '$' : '$';
  const availableAmount = isSwitched ? toSpecialFixed(Number(asset?.usd_value) / Number(asset?.quote_rate) || '0', 2)?.value : toSpecialFixed(asset?.usd_value || '0', 2)?.value;
  const showAvailableAmount = displayAmount === '0';
  const totalValueLength = (showAvailableAmount ? availableAmount.length : displayAmount.length) + displayCurrency.length;
  const getAmountTextSize = (length: number) => {
    if (length <= 7) {
      return 65;
    } else {
      return 65 - Math.log(length - 6) * 15;
    }
  };
  return <div className={`flex flex-col gap-2 ${!asset ? 'opacity-50' : ''}`} data-sentry-component="FromAssetsAmountSelection" data-sentry-source-file="FromAssetsAmountSelection.tsx">
      <div className='h-[70px] text-[65px] flex justify-center items-center gap-2'>
        <div className={classNames('flex justify-center flex-nowrap font-medium', displayCurrency === '$' ? 'flex-row-reverse' : 'flex-row', showAvailableAmount ? 'opacity-30' : '')} style={{
        fontSize: `${getAmountTextSize(totalValueLength)}px`
      }}>
          <span>{showAvailableAmount ? availableAmount : displayAmount}</span>
          <span className={`text-genius-cream/70 inline-flex ${displayCurrency === '$' ? 'scale-90' : ''}`}>
            {displayCurrency}
          </span>
        </div>
        {enableSwitch ? <div onClick={() => setIsSwitched(!isSwitched)} className={'rounded-full w-[25px] h-[25px] flex items-center bg-genius-blue ta-c justify-center'}>
            <BiSortAlt2 className='text-primary' size={12} />
          </div> : null}
      </div>
    </div>;
};
export default FromAssetsAmountSelection;